var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-shrink-0 justify-end"},[_c('span',{attrs:{"role":"button"},on:{"click":_vm.close}},[_c('IconCross',{attrs:{"width":"20px","height":"20px","stroke":"white"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }